(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojoh-ryzer-go-setup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const backToTop = document.querySelector('.ryzer-setup__top-button');
    if (backToTop) {
      let scrollRoot = backToTop.parentElement;
      while (scrollRoot && scrollRoot !== document.body) {
        const overflow = getComputedStyle(scrollRoot).overflowY;
        if (/(auto|scroll)/.test(overflow) && scrollRoot.scrollHeight > scrollRoot.clientHeight) break;
        scrollRoot = scrollRoot.parentElement;
      }
      if (!scrollRoot || scrollRoot === document.body) scrollRoot = window;
      const updateTopButton = () => {
        const offset = scrollRoot === window ? window.scrollY : scrollRoot.scrollTop;
        backToTop.classList.toggle('is-visible', offset > 0);
      };
      scrollRoot.addEventListener('scroll', updateTopButton, { passive: true });
      backToTop.addEventListener('click', (event) => {
        event.preventDefault();
        if (scrollRoot === window) window.scrollTo(0, 0);
        else scrollRoot.scrollTop = 0;
        history.replaceState(null, '', location.pathname + location.search);
        updateTopButton();
      });
      updateTopButton();
    }
    document.querySelectorAll('.ryzer-video__facade').forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.dataset.youtubeId;
        const iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
        iframe.title = button.getAttribute('aria-label') || 'Ryzer Go video';
        iframe.loading = 'lazy';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        button.replaceWith(iframe);
      });
    });
    document.querySelectorAll('.ryzer-drop__input').forEach((input) => {
      input.addEventListener('change', () => {
        const output = input.closest('.ryzer-form__field')?.querySelector('[data-drop-files]');
        if (!output) return;
        output.innerHTML = '';
        Array.from(input.files || []).forEach((file) => {
          const item = document.createElement('span');
          item.className = 'ryzer-drop__file';
          if (file.type.startsWith('image/')) {
            const image = document.createElement('img');
            image.alt = file.name;
            image.src = URL.createObjectURL(file);
            item.appendChild(image);
          } else {
            item.textContent = file.name;
          }
          output.appendChild(item);
        });
      });
    });
    document.querySelectorAll('.ryzer-drop').forEach((zone) => {
      const input = zone.querySelector('.ryzer-drop__input');
      if (!input) return;
      ['dragenter', 'dragover'].forEach((type) => zone.addEventListener(type, (event) => {
        event.preventDefault();
        zone.classList.add('is-dragover');
      }));
      ['dragleave', 'dragend'].forEach((type) => zone.addEventListener(type, () => zone.classList.remove('is-dragover')));
      zone.addEventListener('drop', (event) => {
        event.preventDefault();
        zone.classList.remove('is-dragover');
        const file = Array.from(event.dataTransfer?.files || []).find((item) => /^(image|video)\//.test(item.type));
        if (!file) return;
        const transfer = new DataTransfer();
        transfer.items.add(file);
        input.files = transfer.files;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    document.querySelectorAll('[data-formsubmit]').forEach((form) => {
      const success = form.querySelector('[data-form-success]');
      const error = form.querySelector('[data-form-error]');
      const button = form.querySelector('button[type="submit"]');
      if (!success || !error || !button) return;
      success.setAttribute('role', 'status');
      success.setAttribute('tabindex', '-1');
      error.setAttribute('role', 'alert');
      error.setAttribute('tabindex', '-1');
      let sending = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (sending) return;
        sending = true;
        success.hidden = true;
        error.hidden = true;
        const originalLabel = button.firstChild.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.firstChild.textContent = 'Sending… ';
        try {
          const body = new FormData(form);
          ['_next', '_cc', '_subject', '_template', '_captcha'].forEach((name) => body.delete(name));
          body.set('_gotcha', body.get('_honey') || '');
          body.delete('_honey');
          const response = await fetch(form.action, {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body
          });
          if (!response.ok) throw new Error('Submission failed');
          const result = await response.json();
          if (result.success === false || result.error) throw new Error('Submission failed');
          form.reset();
          form.querySelectorAll('[data-drop-files]').forEach((list) => { list.textContent = ''; });
          success.textContent = 'Thank you! Your message has been sent. We’ll be in touch soon.';
          success.hidden = false;
          success.focus();
        } catch (failure) {
          error.textContent = 'Your message could not be sent. Please try again or email mojoh@mojohgear.com.';
          error.hidden = false;
          error.focus();
        } finally {
          sending = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.firstChild.textContent = originalLabel;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
